export default __webpack_public_path__ + "static/media/008-weather.1485543d.svg";